import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Card } from "@/components/ui/card";
import { Building2, Mail, Phone, Globe } from "lucide-react";

const Impressum = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="py-20">
        <div className="container px-4 max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 mb-6">
              <Building2 className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium">Legal Information</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Impressum
            </h1>
            <p className="text-muted-foreground">
              Information according to § 5 TMG (German Telemedia Act)
            </p>
          </div>

          {/* Company Information */}
          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6">Provider</h2>
            <div className="space-y-4 text-lg">
              <div>
                <p className="font-semibold">Celsios GmbH</p>
                <p className="text-muted-foreground">Cosimastrasse 121</p>
                <p className="text-muted-foreground">81925 München</p>
                <p className="text-muted-foreground">Germany</p>
              </div>
            </div>
          </Card>

          {/* Legal Representative */}
          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6">Managing Director</h2>
            <p className="text-lg">Justus Wiedemann</p>
          </Card>

          {/* Contact Information */}
          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6">Contact</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-primary mt-1" />
                <div>
                  <p className="font-semibold mb-1">E-Mail</p>
                  <a href="mailto:info@celsios.io" className="text-primary hover:underline">
                    info@celsios.io
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Globe className="w-5 h-5 text-primary mt-1" />
                <div>
                  <p className="font-semibold mb-1">Website</p>
                  <a href="https://email2contact.com" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                    https://email2contact.com
                  </a>
                </div>
              </div>
            </div>
          </Card>

          {/* Register Information */}
          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6">Company Registration</h2>
            <div className="space-y-3 text-muted-foreground">
              <p><strong className="text-foreground">Legal Form:</strong> Limited Liability Company (GmbH)</p>
              <p><strong className="text-foreground">Register Court:</strong> District Court Frankfurt am Main</p>
              <p><strong className="text-foreground">Commercial Register Number:</strong> HRB 134969</p>
            </div>
          </Card>

          {/* VAT */}
          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6">VAT Identification Number</h2>
            <p className="text-muted-foreground">
              VAT identification number according to § 27a UStG: DE442429324
            </p>
          </Card>

          {/* Responsible for Content */}
          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6">Responsible for Content</h2>
            <p className="text-muted-foreground">
              Responsible for content according to § 55 Abs. 2 RStV:
            </p>
            <div className="mt-4">
              <p className="font-semibold">Justus Wiedemann</p>
              <p className="text-muted-foreground">Cosimastrasse 121</p>
              <p className="text-muted-foreground">81925 München</p>
              <p className="text-muted-foreground">Germany</p>
            </div>
          </Card>

          {/* Dispute Resolution */}
          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6">Dispute Resolution</h2>
            <p className="text-muted-foreground mb-4">
              The European Commission provides a platform for online dispute resolution (ODR):
            </p>
            <a 
              href="https://ec.europa.eu/consumers/odr" 
              className="text-primary hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            <p className="text-muted-foreground mt-4">
              We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.
            </p>
          </Card>

          {/* Liability */}
          <Card className="p-8">
            <h2 className="text-2xl font-bold mb-6">Liability Disclaimer</h2>
            
            <h3 className="text-xl font-semibold mb-3">Liability for Content</h3>
            <p className="text-muted-foreground mb-6">
              As a service provider, we are responsible for our own content on these pages according to § 7 para.1 TMG under general law. However, according to §§ 8 to 10 TMG, we are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information according to general laws remain unaffected.
            </p>

            <h3 className="text-xl font-semibold mb-3">Liability for Links</h3>
            <p className="text-muted-foreground mb-6">
              Our website contains links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for this external content. The respective provider or operator of the pages is always responsible for the content of the linked pages.
            </p>

            <h3 className="text-xl font-semibold mb-3">Copyright</h3>
            <p className="text-muted-foreground">
              The content and works created by the site operators on these pages are subject to German copyright law. The reproduction, editing, distribution and any kind of use outside the limits of copyright require the written consent of the respective author or creator.
            </p>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Impressum;
